import { call, put, takeEvery } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as Actions from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.SETTING_LIST_API,
    formData
  )

  return handleRequest(request);
}
function updateStoreRequestApi(formData) {
  const request = axiosApi().post(
    Constants.SETTING_UPDATE_STORE_API,
    formData
  )
  return handleRequest(request);
}

function* settingUpdateStoreFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(updateStoreRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(Actions.settingUpdateStoreSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data);
    }
  } catch (error) {
    yield put(Actions.settingUpdateStoreError(error))
  }
}
function* settingListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(Actions.settingListSuccess(results.data))

  } catch (error) {
    yield put(Actions.settingListError(error))
  }
}

function* settingGetConfigRequestFlow({ payload, callback }) {
  try {
    const request = axiosApi().post(
      Constants.SETTING_GET_CONFIG_API,
      payload
    )
    // grab the client from our action
    const response = yield call(handleRequest, request)
    if (typeof callback == 'function') {
      yield call(callback, response);
    }
  } catch (error) {
    yield put(Actions.settingListError(error))
  }
}

function* settingWatcher() {
  yield [
    takeEvery(Constants.SETTING_LIST_REQUESTING, settingListRequestFlow),
    takeEvery(Constants.SETTING_UPDATE_STORE_REQUESTING, settingUpdateStoreFlow),
    takeEvery(Constants.SETTING_GET_CONFIG_REQUESTING, settingGetConfigRequestFlow)
  ]
}

export default settingWatcher



// WEBPACK FOOTER //
// ./src/views/Setting/sagas.js